/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Ourcompany_Label1Inputs */

const ja_company_ourcompany_label1 = /** @type {(inputs: Company_Ourcompany_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINについて`)
};

const en_company_ourcompany_label1 = /** @type {(inputs: Company_Ourcompany_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Company`)
};

/**
* | output |
* | --- |
* | "Our Company" |
*
* @param {Company_Ourcompany_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_ourcompany_label1 = /** @type {((inputs?: Company_Ourcompany_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Ourcompany_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_ourcompany_label1(inputs)
	return en_company_ourcompany_label1(inputs)
});
export { company_ourcompany_label1 as "company_ourCompany_label" }